import { useState, useEffect, useRef } from 'react';
import './CombinedPhoneInput.css';
 
export const CombinedPhoneInput = ({ phoneData, onPhoneSubmit, countryCode, setCountryCode }) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const bottomRef = useRef(null);
 
  // Initialize selected country when component mounts
  useEffect(() => {
   if (phoneData && phoneData.countries && phoneData.countries.length > 0) {
      // Check if defaultCountry is provided (not null)
      if (phoneData.defaultCountry) {
        // Find default country from the list
        const defaultCountry = phoneData.countries.find(country => country.code === phoneData.defaultCountry);
        setSelectedCountry(defaultCountry || null);
      } else {
        // No country selected by default
        setSelectedCountry(null);
      }
   }    
 }, [phoneData]);
  
  useEffect(()=>{
   requestAnimationFrame(()=>{
     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
   });
 }, []);
 
  const handleCountryChange = (event) => {
    const callingCode = event.target.value;
    if (callingCode) {
      const country = phoneData.countries.find(c => c.callingCode === callingCode);
   if (country) {
     setSelectedCountry(country);
      }
    } else {
      setSelectedCountry(null);
   }
 };
 
  const handlePhoneNumberChange = (event) => {
   // Only allow numbers
   const value = event.target.value.replace(/\D/g, '');
   setPhoneNumber(value);
 };
 
  const handleSubmit = () => {
   if (!phoneNumber.trim()) {
      alert('I can have a Service Desk agent call you back. Please share the best number to reach you.');     
      return;
   }
 
   if (!selectedCountry && !countryCode) {
     alert('Please select a country');
     return;
   }
 
   const fullNumber = ((countryCode && !selectedCountry)? countryCode : selectedCountry).callingCode + phoneNumber;
   onPhoneSubmit(fullNumber);
 };
 
  const handleKeyPress = (event) => {
   if (event.key === 'Enter') {
     handleSubmit();
   }
 };

 if(countryCode && typeof(countryCode)!=="object"){
  const dataWithCode = phoneData?.countries.filter((country) =>{    
    return country.code.trim().toLowerCase() === countryCode.trim().toLowerCase();
  });

  if(dataWithCode[0]){
    setCountryCode(dataWithCode[0]);
  }
 }
 
  if (!phoneData || !phoneData.countries) {
   return <div>Loading phone input...</div>;
 }
 
  return (    
    <div className="combined-phone-input-container">
     <div className="phone-input-header">
       <p className="phone-input-text">{phoneData?.text}</p>
     </div>
    
     <div className="phone-input-group">
        {/* Country Code Dropdown - "Select Country" as default */}
       <select        
         className="country-code-selector form-select"
          value={selectedCountry ? selectedCountry.callingCode : ""}
         onChange={handleCountryChange}
          style={{cursor: "pointer"}}
       >
          <option value={countryCode}>{(countryCode)? countryCode.code + " " + countryCode.callingCode : `Select Country`}</option>
         {phoneData?.countries.map((country) => (
           <option 
             key={country.code} 
             value={country.callingCode}
           >
             {country.code} {country.callingCode}
           </option>
         ))}
       </select>
 
        {/* Phone Number Input */}
       <input        
         ref={bottomRef} 
         type="tel"
         className="phone-number-input form-control"
          placeholder="Enter phone number"
         value={phoneNumber}
         onChange={handlePhoneNumberChange}
         onKeyPress={handleKeyPress}
         maxLength="15"
       />
     </div>
 
     <button               
       className={"submit-phone-btn btn btn-outline-secondary button-hover"}
       style={{ color: "#7f7f7f", minWidth: "120px"}}
       onClick={handleSubmit}
     >
       Submit Phone Number
     </button>
   </div>
  );
};